import {BehaviorSubject, concat, forkJoin, forkJoin as observableForkJoin, Observable, of, Subscription} from 'rxjs';
import {Constants} from './../../commons/Constants';

import {flatMap, map, mergeMap, scan, tap} from 'rxjs/operators';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AccessGroup, Role, User} from 'vasat';

import {MapService} from '../../commons/map.service';
import {AppService} from '../../commons/app.service';
import {AclService} from '../../commons/acl/acl.service';
import {Account, AccountPlan, FourDService, Project} from '4d-mapper';
import {MatCheckbox, MatDialog, MatSnackBar} from '@angular/material';
import {AddUserDialog} from './user-add.dialog';
import {FormControl} from '@angular/forms';
import {ShareProjectDialog} from './share-project/share-project-dialog.component';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';

import {TranslateService} from '@ngx-translate/core'; 
import { UiManagerService } from '@src/app/xs/services/ui/ui-manager.service';

export interface UserStub{
  user:User
  group:AccessGroup
  isAdmin:boolean
  isInvite:boolean
}

@Component({
  selector: 'users-comp',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent extends AppBaseComponent implements OnInit, OnDestroy {

  error: string
  success: string
  groups: AccessGroup[] = []
  userList = new BehaviorSubject<UserStub[]>([])

  private accountPlan: string;
  projects: Project[];
  sharedProjectControl = new FormControl();

  // roles: Set<any> = null ;
  // roleSelected: string = null;

  allowed: any = null;

  userRoles: object = null;
  test: any = null;

  resources: object = null;

  roles:Role[];

  viewRole:string = null;
  viewRoleResources:any = null;
  viewRoleAllowed:any = null;



  

  curUser:UserStub

  constructor
  (public fourD: FourDService, 
    public mapService: MapService, 
    public service: AppService, 
    public permissions: AclService, 
    public router: Router,
    public snackBar: MatSnackBar, 
    public dialog: MatDialog, 
    public uiManager: UiManagerService,
    private activeRoute: ActivatedRoute, 
    applicationEvents:XsApplicationEventsService, 
    private t:TranslateService) {
    super(service, router, snackBar, dialog, applicationEvents);
  
  }

  init(){

    this.addSubscription( 'userReady', this.fourD.onSocketCommand('user_joined').subscribe(s => {
      console.log('hb!!!!')
      this.onReady()
    }))

    // fetch all features
    // result should go in this.viewRoleResources

    // fetch all roles
    this.fourD.V.searchByObject(Role).equals("desc","4D Mapper|4D User").queryObservable().subscribe(s => {
      this.roles = s.items;
    })
    
  }
  onReady() {

  
    // fetch all roles
    // this.roles = this.permissions.getRoles();

    // if a user has no role, give them one of these defaults
    let defaults = this.permissions.getDefaults();

    Constants.showHangOn();

    // get all actual users and user groups
    this.refreshUserGroups().pipe(flatMap(_ => this.refreshInvited())).subscribe( ret => {
    /*
      // shortcut, saving the list of user roles (what given, or set by default)
      let a = this.fourD.activeTeam;

      // do we support multiple roles per user?
      const supportMulti = false;

      // create a new list of all users role(s)
      let userRoles = a['__acl_user_roles'] ? a['__acl_user_roles'] : {};

  
      // go through every user, and set up a default is one is missing
      this.users.forEach ( u => {

        // init
        if ( ! userRoles[u.id] ) {
          userRoles[u.id] = supportMulti ? [] : '';
        }

        // no entries; needs default
        if ( 
          ( supportMulti && userRoles[u.id].length == 0 )
            ||
          ( !supportMulti && userRoles[u.id] == '' ) 
          ) {
          if ( this.isUserOnAdminGroup ( u ) ) {
            if ( defaults.get('admin') ) {
              if ( supportMulti ) {
                userRoles[u.id].push(defaults.get('admin'));
              } else {
                userRoles[u.id] = defaults.get('admin');
              }
            }
          } else {
            if ( defaults.get('user') ) {
              if ( supportMulti ) {
                userRoles[u.id].push(defaults.get('user'));
              } else {
                userRoles[u.id] = defaults.get('user');
              }
            }
          }
        }
      });
      
      // make sure it's a nice clean object (no leaks!)
      for (var propName in this.userRoles) { 
        if (this.userRoles[propName] === null || this.userRoles[propName] === undefined) {
          delete this.userRoles[propName];
        }
      }

      // set it to the model
      this.userRoles = userRoles;

      // save a copy back to the Account
      a['__acl_user_roles'] = this.cleanObject ( this.userRoles );
      a.saveObservable().subscribe();

      // get all projects for all these users
      this.getProjects();

      // first time force role changes
      this.onRoleChange() ;
      this.onRolesChange() ;

      });
  */
      // hide the 'hang on, working' message
      Constants.hideHangOn();

    });
  
  }
  refreshInvited(){
    return this.fourD.activeTeam.invitedUsers.queryObservable().pipe(tap(s => 
      this.userList.next(this.userList.value.concat(s.items.map(ii => { return {user:ii,group:null,isAdmin:false,isInvite:true}})))
    ))
  }
  deleteInviteUser(u:User){
    this.fourD.activeTeam.invitedUsers.removeObservable(u).subscribe(s => { this.refreshInvited()})
  }
  cleanObject (obj) {
    for (var propName in obj) { 
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }
  saveUserRules(user_id){

  }

  onRolesChange() {
    this.fourD.activeTeam['__acl_user_roles'] = this.userRoles;
    this.fourD.activeTeam.saveObservable().subscribe();
  }

  onRoleChange () {

    // what am I allowed to do?
    console.log('users.comp');
    this.allowed = this.permissions.getAccess ( this.permissions.roleSelected, true ); // force refresh of role access
    this.viewRoleAllowed = this.allowed;

    // clone resources for presentation of access rules
    this.resources = this.permissions.deepClone ( this.permissions.access_inv );
    this.viewRoleResources = this.resources;

  }

  viewRoleAccess( event:any ) {

    const roleId = event.value;

    let role = this.roles.find( f => f.id == roleId );

    // what am I allowed to do?
    console.log('users.comp', event, roleId, role );

    // here; fetch ACL rules for this role



    // this.viewRoleAllowed = this.permissions.getAccess ( role, true ); // force refresh of role access

    // clone resources for presentation of access rules
    // this.viewRoleResources = this.permissions.deepClone ( this.permissions.access_inv );

    console.log ( 'changeViewRole', role, this.viewRoleAllowed, this.viewRoleResources );

  }

  // we want sometimes to not sort the order of iterated objects
  keyOrderNone = (a: any, b: any): number => {
    return 0;
  }
/*
  private getProjects() {
    this.fourD.V.searchByObject(Project).limit(1000).queryObservable().subscribe(value => {
      this.projects = value.items;
      this.projects.forEach(p => {
        p.shareUsers.queryObservable().subscribe(shareUsers => {
          shareUsers.items.forEach(user => {
            if (this.users.find(value1 => value1.id === user.id)) {
              if (!this.users.find(value1 => value1.id === user.id)['projects']) {
                this.users.find(value1 => value1.id === user.id)['projects'] = [];
              }
              this.users.find(value1 => value1.id === user.id)['projects'].push(p);
            }
          })
        });
      })
    });
  }
*/

  refreshUserGroups(): Observable<void> {
    //this.apis = this.fourD.apis.filter(ap => ap.account.id == this.fourD.zzz.id)
    return this.fourD.activeTeam.accountGroups.queryObservable().pipe(
      map(res => this.groups = res.items),
      mergeMap(res => {
        let usersQueryObs: Observable<UserStub[]>[] = []
        // Go through all AccessGroups and get the users obeservable and attach them to a forkJoin
        for (var i = 0; i < this.groups.length; i++) {
          let group: AccessGroup = this.groups[i]
          usersQueryObs.push(group.users.queryObservable().pipe(map(i => 
            i.items.map(u => { return {user:u,group:group, isAdmin: group.uid.endsWith('_admins'), isInvite:false}})
          )))
        }
        return forkJoin(usersQueryObs).pipe(map(a => {
          var res = <UserStub[]>[]
          a.forEach(aa => aa.forEach(aaa => res.push(aaa)))
          return res
        }))
      }),
      map(result => {
        
        this.userList.next(result.sort((a, b) => a.user.name.localeCompare(b.user.name)))
        this.loading = false;
      }),)
  }

  userIndex(list: User[], user: User) {
    var index = -1
    for (var i = 0; i < list.length; i++) {
      let u = list[i]
      if (u.id == user.id) index = i
    }
    return index
  }

  changeUserAccess(event, user: User, group: AccessGroup) {
    // If check is true it means we are adding the user to the group
    if (event.checked) {
      group.users.addObserveable(user).pipe(
        mergeMap(e => {
          return this.refreshUserGroups()
        }))
        .subscribe(
          succ => {
            this.openSnackBarSuccess('USER_ADMIN.ADDED')
          }, err => {
            this.openSnackBarError('ERROR.VASAT', '', err)
          }
        )
    } else {
      let remove = () => {
        group.users.removeObservable(user).pipe(
          mergeMap(e => {
            return this.refreshUserGroups()
          }))
          .subscribe(
            succ => {
              this.openSnackBarSuccess('USER_ADMIN.REMOVED')
            }, err => {
              this.openSnackBarError('ERROR.VASAT', '', err)
            }
          )
      }
      // If we are removing user from a group check it belongs to other groups, otherwise present a notification
      if (this.getUserGroups(user) > 1) {
        remove()
      } else {
        forkJoin([
        this.t.get('GENERIC.YES'),
        this.t.get('GENERIC.NO')
        ]).subscribe(([yes,no]) => 
          // Show notification
          this.snotifyService.confirm('Would you like to remove user from all groups?', {
            showProgressBar: false,
            closeOnClick: false,
            buttons: [
              {
                text: yes, action: (toast) => {
                  remove()
                }, bold: true
              },
              {
                text: no, action: (toast) => {
                  this.snotifyService.remove(toast.id)
                }, bold: true
              }
            ]
          })
        )
      }
    }
  }

  changeAccessValidation(checkbox: MatCheckbox, user: User, group: AccessGroup) {
    if (checkbox.checked) {
      // Don't allow to remove all admin users
      if (this.isAdminGroup(group) && !(group['cachedUsers'].length > 1)) {
        this.openSnackBarWarn('USER_ADMIN.NEED_ADMIN')
        return false
      }
      // If checkbox value is checked it means we are about to remove the user from the group so lets check user belongs to more groups
      else if (!(this.getUserGroups(user) > 1)) {
        this.openSnackBarWarn('USER_ADMIN.NO_GROUPS')
        return false
      } else {
        return true
      }

    } else {
      return true
    }
  }

  inviteUser() {
    let dialogRef = this.dialog.open(AddUserDialog, {
      //width: '350px',
      data: {groups: this.groups}
    })
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.fourD.V.api('/app/Account/' + this.fourD.activeTeam.id + '/invite/-1', 'post', res.user)
          .subscribe(
            res1 => {
              
              this.curUser = {
                user:new User(this.service.V,res1.id).set(res1),
                isAdmin:false,
                isInvite:false,
                group:this.groups.find(a => !a.uid.endsWith('_admins'))

              }
              this.openSnackBarSuccess('SETTINGS.INVITE_SENT')
              // res1.group.users.queryObservable().subscribe();
              this.refreshUserGroups().pipe(flatMap(_ => this.refreshInvited()
              )).subscribe()
            }, err => {
              if (err.status == 92002)
                this.openDialog('PLAN.QUOTA', 'PLAN.QUOTA_DESC_USER')
              else
                this.openSnackBarError('ERROR.VASAT', '', err)
            }
          )
      }
    })
  }

  shareProject(user: User) {
    let dialogRef = this.dialog.open(ShareProjectDialog, {
      //width: '350px',
      data: {
        user: user,
        projects: this.projects
      }
    });
    dialogRef.afterClosed().subscribe(res => {
    })
  }

  /**
   * Cheks if the passed user belongs to the passed AccessGroup
   * @param user The user
   * @param group The AccessGroup
   */
  isUserOnGroup(user: User, group: AccessGroup) {
    return group['cachedUsers'] ? group['cachedUsers'].find(u => u.id == user.id) : false
  }

  getUserGroups(user: User) {
    var res: number = 0
    for (var i = 0; i < this.groups.length; i++) {
      if (this.isUserOnGroup(user, this.groups[i])) res++
    }
    return res
  }

  /**
   * Check if the user is in admin group
   * @param user
   */
  isUserOnAdminGroup(user: User) {
    let adminGroup = this.groups.find(g => this.isAdminGroup(g))
    if (adminGroup) {
      return this.isUserOnGroup(user, adminGroup)
    } else {
      return false
    }
  }

  /**
   * Check if the group is the Admin group
   * @param group
   */
  isAdminGroup(group: AccessGroup): boolean {
    if (group && group.uid) {
      return group.uid.indexOf('_admins') != -1
    } else {
      return false
    }
  }


  addTeam() {

    var inp = {}
    this.openDialog('SETTINGS.TEAM_NAME', '', 'GENERIC.OK', 'GENERIC.CANCEL', inp).subscribe(s => {
      if (s)
        new Account(this.fourD.V).set({name: s, uid: s, parent: this.fourD.activeTeam}).saveObservable().subscribe(s => {
            this.fourD.teams.push(s)
            this.openSnackBarInfo('GENERIC.ADDED')
          },
          e => this.openSnackBarError('GENERIC.ADDED_ERROR', e.message)
        )
    })

  }

  deleteUser(user: User) {

    if (this.service.myProfile.id == user.id) {
      this.openSnackBarError('USER_ADMIN.DELETE_ERROR');
      return;
    }
    this.openConfirmDelete(() => {
      this.loading = true;
      observableForkJoin(this.projects.map(project => {
        if (user['projects'] && user['projects'].indexOf(project) !== -1) {
          return project.shareUsers.removeObservable(user);
        } else {
          return of('');
        }
      })).subscribe(_ => {
        let a = this.fourD.activeTeam
        delete a['__acl_user_roles']['' + user.id]
        a.saveObservable().subscribe()
        observableForkJoin(this.groups.map(group => group.users.removeObservable(user))).subscribe(_ => {
          this.refreshUserGroups().subscribe()
          this.openSnackBarSuccess('USER_ADMIN.USER_DELETED');
        });
      });
    }, user.name);
  }
}
